import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBurgerMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 18.75H4V17.25H16V18.75ZM20 12.75H4V11.25H20V12.75ZM20 6.75H4V5.25H20V6.75Z"
	})
});
export default SvgBurgerMenu;
